import styled from "styled-components";

export const SelectMultipleContainer = styled.div<any>`
  width: 100%;
`;
